/**
 * Раскладка карточки показателя — одна для живой `KpiCard` и её скелетона: общая величина лежит здесь,
 * а не в двух копиях, иначе правка в одной из них сдвигает ряд после загрузки (`.claude/docs/skeleton-kit.md`).
 */

export const KPI_GRID_CLASS = 'grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4';

/** Поля и радиус задаёт `UDCard radius="panel" padding="lg"`, здесь — только раскладка содержимого. */
export const KPI_CARD_CLASS = 'flex min-w-0 flex-col gap-4';

export const KPI_TOP_CLASS = 'flex min-w-0 items-center gap-3.5';

/** Сторона значка карточки, px: ее получают и `IconBadge` живой карточки (проп `size`), и плашка значка в скелетоне. */
export const KPI_ICON_SIZE = 44;

/** Раскладка значения без цвета: цвет — у живой карточки; плашка скелетона красится сама (`text-transparent`). */
export const KPI_VALUE_CLASS = 'leading-none';

export const KPI_PROGRESS_CLASS = 'flex flex-col gap-1';

export const KPI_PROGRESS_TRACK_CLASS = 'h-1.5 rounded-pill';
